import { get } from '../utils/axios'

export const getProvincesAPI = async () => {
  return await get('address/provinces')
}

export const getDistrictsAPI = async (id) => {
  const param = { provinceId: id }
  return await get('address/districts', param)
}
export const getSubdistrictsAPI = async (id) => {
  const param = { districtId: id }
  return await get('address/subdistricts', param)
}
